import * as React from 'react'
import { withRouter } from 'next/router'
import { getWellnessProps } from '../../models/Wellness'
import type { WellnessCategoryPageRowType, WellnessPropsType } from '../../models/Wellness'
import DiscoverLayout from '@components/Discover/DiscoverLayout'
import { DiscoverMenu } from '@components/Discover/DiscoverMenu'
import DeepLinkCardsCarousel from '@components/Discover/DeepLinkCardsCarousel'
import styled from 'styled-components'
import { config } from 'react-awesome-styled-grid'
function Wellness (props: WellnessPropsType): React.ReactNode {
  return (
    <DiscoverLayout background title={'Explore Wellness stories on Dipsea'}>
      <div>
        <DiscoverMenu page={'wellness'}/>
          {props.pageRows.map((pageRow: WellnessCategoryPageRowType, index: number): React.ReactNode => (
            <SectionSeparator key={index} ><DeepLinkCardsCarousel {...pageRow} /></SectionSeparator>
          ))}
      </div>
    </DiscoverLayout>
  )
}
export default withRouter(Wellness as any) as any

export async function getStaticProps (): Promise<{ props: WellnessPropsType }> {
  const wellness = await getWellnessProps()
  return { props: wellness }
}

const SectionSeparator = styled.div<any>`
    width: 100%;
    margin-top: 32px;
    ${(props: any): any => config(props).media.xs`
  `}
    ${(props: any): any => config(props).media.sm`
  `}
    ${(props: any): any => config(props).media.md`
      margin-top: 48px;
    `}
`
